import { CurrencyCode } from '../currencies/currencies.seed';
import { ExchangeRate, generateExchangeRateObject } from '../exchange-rates';

export interface GenerateNativeExchangeRatesOptions {
  readonly currencyCodes: readonly CurrencyCode[];
}

export function generateNativeExchangeRateObject(
  currencyCode: CurrencyCode,
): ExchangeRate {
  return generateExchangeRateObject(currencyCode);
}
